import _ from 'lodash';

import displayApis from '../enums/displayApis';

const PROMOTION_UPDATE_THROTTLE = 500; //only call promotion updates once in 500ms

/**
 * window.NGX.api is a function exposed by display, that allows communication between coreapp and display.
 * This function will safely execute a display api. Needed in case the display service is down for some reason.
 */
const _executeDisplayApi = (displayApi, params) => {
  if (!!window.NGX && !!window.NGX.api) {
    window.NGX.api(displayApi, params);
  }
};

/**
 * Throttled function to call display api for updating a promotion preview
 */
const updatePromotionPreview = _.throttle(({ activePromotionId, promotions }) => {
  if (!!promotions && !_.isEmpty(promotions)) {
    _executeDisplayApi(displayApis.UPDATE_PROMOTION, { activePromotionId, promotions: JSON.stringify(promotions) });
  }
}, PROMOTION_UPDATE_THROTTLE);

const resetSession = () => {
  _executeDisplayApi(displayApis.RESET_SESSION);
};

export default {
  updatePromotionPreview,
  resetSession,
};
